// utilities assume direct access to datomic-http
// in test environment

import { path } from 'ramda'
import { parseCookie } from 'cookie'
import config from 'config'

const getCookie = req => {
  if (typeof document === 'object' && !req) {
    return path(['cookie'], document)
  }
  if (req) {
    return path(['headers', 'cookie'], req)
  }
}

export const getSession = req => {
  const cookieStr = getCookie(req)
  if (cookieStr) {
    return parseCookie(cookieStr)[config.NEXT_PUBLIC_COOKIE_NAME]
  }
}

export const getCsrf = req => {
  const cookieStr = getCookie(req)
  if (cookieStr) {
    return parseCookie(cookieStr)[config.NEXT_PUBLIC_COOKIE_NAME + '_CSRF']
  }
}
